import { Component } from '@angular/core';
import { HeroSectionComponent } from './hero-section/hero-section.component';
import { FeatureSectionComponent } from './feature-section/feature-section.component';
import { StatsSectionComponent } from './stats-section/stats-section.component';

@Component({
  selector: 'app-home',
  imports: [
    HeroSectionComponent,
    FeatureSectionComponent,
    StatsSectionComponent,
  ],
  templateUrl: './home.component.html',
  standalone: true,
  styleUrl: './home.component.scss',
  host: { id: 'home-page' },
})
export class HomeComponent {}
